export default __webpack_public_path__ + "static/media/logo-black.bcb6df38.svg";